/* eslint-disable */
import { data_ecotrack_V2 as noestCommunes } from '../data_ecotrack_V2';

const normalizeName = (value) => String(value ?? '')
  .trim()
  .replace(/\s+/g, ' ');

export default function getNoestCommuneFrenchName(communeName, wilayaId) {
  const normalizedCommuneName = normalizeName(communeName);
  const normalizedWilayaId = Number(wilayaId);

  const commune = noestCommunes.find(
    (item) => (
      item?.is_active !== 0
      && normalizeName(item?.commune_name) === normalizedCommuneName
      && (!normalizedWilayaId || Number(item?.wilaya_id) === normalizedWilayaId)
    ),
  );

  return normalizeName(commune?.nom);
}
